/* eslint-disable */
export const optionsActivity = [
  { value: 'popular', label: 'Popular Activities', icon: 'activity' },
  { value: 'art-and-craft-workshops', label: 'Art & Craft Workshops', icon: 'picture-frame' },
  { value: 'cooking', label: 'Cooking', icon: 'cooking' },
  { value: 'fitness-and-wellness', label: 'Fitness & Wellness', icon: 'healthcare' },
  { value: 'floating-market', label: 'Floating Markets', icon: 'floating-market' },
  { value: 'food-and-drink', label: 'Food & Drink', icon: 'restaurant' },
  { value: 'fun-and-adventure', label: 'Fun & Adventure', icon: 'activity' },
  { value: 'history-and-culture', label: 'History & Culture', icon: 'pagonda' },
  { value: 'local-life', label: 'Local Life', icon: 'thai-house' },
  { value: 'local-ride', label: 'Local Ride', icon: 'tuktuk' },
  { value: 'nature', label: 'Nature', icon: 'tree' },
  { value: 'night-activities', label: 'Night Activities', icon: 'night' },
  { value: 'shopping', label: 'Shopping', icon: 'shopping' },
  { value: 'volunteering-and-social-impact', label: 'Volunteering & Social Impact', icon: 'volunteer' },
];

// activityValues --> Array<'popular' | 'art-and-craft-workshops' | 'cooking' | ...>
export function getActivityOptionsFromValues (activityValues = []) {
  return optionsActivity.filter(
    (option) => (activityValues).includes(option.value)
  )
}
